<div class="host-order-detail-sidebar">
  <!-- <div class="reservation-detail" *ngIf="selectedReservation">
    <host-house-order-detail
      [code]="selectedReservation"
      [from]="'calendar'"
    ></host-house-order-detail>
  </div> -->
  <div class="reservation-detail" *ngIf="pageName === PageName.OrderDetail">
    <host-house-order-detail
      [code]="pagePayload?.code"
      [pageType]="'sidebar'"
      [activatedIndex]="pagePayload?.index"
      [backArrow]="pagePayload?.backArrow"
    ></host-house-order-detail>
  </div>
  <div class="reservation-detail" *ngIf="pageName === PageName.GuestDetail">
    <host-order-guest-detail [guestId]="pagePayload?.id"></host-order-guest-detail>
  </div>
  <!-- <div class="reservation-detail" *ngIf="orderPageInfo?.page === 1">
    <host-order-guest-detail
      [guestId]="orderPageInfo?.id"
      [code]="orderPageInfo?.code"
    ></host-order-guest-detail>
  </div> -->
  <!-- <div class="reservation-detail" *ngIf="orderPageInfo?.page === 2">
    <host-order-guest-similar
      [originGuestId]="orderPageInfo?.id"
    ></host-order-guest-similar>
  </div> -->
  <div class="reservation-detail" *ngIf="pageName === PageName.GuestSimilar">
    <host-order-guest-similar [guestId]="pagePayload?.id"></host-order-guest-similar>
  </div>

  <div class="reservation-detail" *ngIf="pageName === PageName.RateDetail">
    <host-rate-detail [code]="pagePayload?.code"></host-rate-detail>
  </div>
  <!-- <div
    class="reservation-detail"
    *ngIf="[0, 3, 4].includes(orderPageInfo?.page) && !selectedReservation"
  >
    <host-house-order-detail
      [code]="orderPageInfo?.code"
      [from]="'calendar'"
      [activatedIndex]="orderPageInfo?.tab"
    ></host-house-order-detail>
  </div> -->
</div>
